<template>
  <div class="app-container circle-new-edit">
    <basic-container v-loading="loading">
      <el-row>
        <el-col :span="3">
          <div>封面</div>
        </el-col>
        <el-col :span="12">
          <div>
            <img ref="originCover" v-show="showCover" class="origin-cover" />
            <el-upload
              action=""
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              :auto-upload="false"
              :multiple="false"
              :limit="1"
              :on-exceed="handleExceed"
              list-type="picture-card"
              >
              <el-button size="small" type="primary">{{id ? '重新上传' : '点击上传'}}</el-button>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div>名称</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input v-model.trim="name" :maxlength="30"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div>描述</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input v-model.trim="description" :maxlength="100"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div>品种</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-select v-model="tag" value-key="tagId" filterable>
              <el-option
                v-for="item in tagOptions"
                :key="item.tagId"
                :label="item.tagName"
                :value="item"
                >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div>地区</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input v-model.trim="location" :maxlength="30"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div>关联企业</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input v-model.trim="company" :maxlength="30"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div>管理员</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-select v-model="ownerId" filterable>
              <el-option
                v-for="item in memberOptions"
                :key="item.memberId"
                :label="item.name"
                :value="item.memberId"
                >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <div>
          <el-button @click="submit" type="primary">提交</el-button>
        </div>
      </el-row>
    </basic-container>
  </div>
</template>
<script>
import { getFileKey } from '@/util/util'
import { getOSSSign, uploadImage } from '@/api/basic/aliyunoss'
import { getAllMembersAdmin } from '@/api/admin/member'
import { getTagsByType } from '@/api/basic/tagtype'
import { addObj, getObj, putObj, fetchTagList } from '@/api/post/circle'

const initPage = vm => {
  getAllMembersAdmin().then(response => {
    if (Array.isArray(response.data.data)) {
      vm.memberOptions = response.data.data.map(x => {
        return {
          memberId: x.memberId,
          name: x.nickname
        }
      })
    }
  })

  getTagsByType({type: 3}).then(response => {
    if (Array.isArray(response.data.data)) {
      vm.tagOptions = response.data.data.map(x => {
        return {
          tagId: x.id,
          tagName: x.name
        }
      })
    }
  })
}

const formatDetail = (vm, data) => {
  vm.coverImg = data.coverImg
  vm.name = data.circleName
  vm.ownerId = data.ownerId
  vm.description = data.description
  vm.tag = {
    tagId: data.tagId,
    tagName: data.tagName
  }
  vm.location = data.location
  vm.company = data.company
}

const formatTagData = (vm, data) => {
  if (Array.isArray(data)) {
    return data.map(tag => tag.tagId)
  } else {
    return []
  }
}

export default {
  data () {
    return {
      loading: false,
      id: '',
      coverImg: '',
      name: '',
      description: '',
      tag: null,
      tagOptions: [],
      location: '',
      company: '',
      ownerId: '',
      memberOptions: [],
      showCover: false,
      originCover: ''
    }
  },
  mounted () {
    initPage(this)
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      getObj(this.id).then(response => {
        formatDetail(this, response.data.data)
        this.originCover = this.coverImg
        if (this.originCover) {
          this.showCover = true
          this.$refs['originCover'].src = this.originCover
        }
      }).catch(error => {
        console.error(error)
        vm.$message({
          message: error,
          type: 'error'
        })
      })
      fetchTagList(this.id).then(response => {
        let tagIds = formatTagData(this, response.data.data)
        // this.$refs['tags'].tagIds = tagIds
      }).catch(error => {
        console.error(error)
        this.$message({
          message: "获取圈子标签失败",
          type: "error"
        })
      })
    }
  },
  methods: {
    handleExceed () {
      this.$message({
        message: '只能选择一张图片',
        type: 'error'
      })
    },
    handleImageRemove () {
      this.coverImg = null
      if (this.originCover) {
        this.showCover = true
        this.$refs['originCover'].src = this.originCover
      }
    },
    handleImageChange (file, fileList) {
      if (!fileList || fileList.length === 0) {
        return false
      }
      // 获取文件路径名
      getFileKey(file.raw, (fileKey) => {
        // 获取阿里云签名
        getOSSSign().then(response => {
          let cdnHost = response.data.data.cdnHost
          let host = response.data.data.host
          let params = new FormData()
          params.append('name', file.name)
          params.append('key', fileKey)
          params.append('policy', response.data.data.policy)
          params.append('OSSAccessKeyId', response.data.data.accessKeyId)
          params.append('success_action_status', 200)
          params.append('signature', response.data.data.signature)
          params.append('file', file.raw, file.name)
          console.log('key...', fileKey)
          uploadImage(host, params).then(response => {
            this.$message({
              message: '上传成功',
              type: 'success'
            })
            this.coverImg = cdnHost + '/' + fileKey
            this.showCover = false
          }).catch(error => {
            console.error(error)
            this.$message({
              message: '上传失败',
              type: 'error'
            })
          })
        })
      })
      return false
    },
    validate () {
      if (!this.name) {
        this.$message({
          message: '圈子名称不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.description) {
        this.$message({
          message: '圈子描述不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.tag) {
        this.$message({
          message: '圈子品种不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.ownerId) {
        this.$message({
          message: '圈子管理员不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.coverImg && !this.id) {
        this.$message({
          message: '圈子封面不能为空',
          type: 'error'
        })
        return false
      }
      return true
    },
    getParams () {
      return {
        id: this.id,
        circleName: this.name,
        circleType: 0,
        description: this.description,
        coverImg: this.coverImg,
        tagId: this.tag.tagId,
        tagName: this.tag.tagName,
        company: this.company,
        location: this.location,
        ownerId: this.ownerId,
        members: [{
          id: this.ownerId,
          memberType: 1
        }],
        tags: this.$refs['tags'].tagIds.map(x => {return {tagId: x}})
      }
    },
    submit () {
      if (!this.validate()) {
        return false
      }
      if (!this.id) {
        addObj(this.getParams()).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$router.push({
              path: `/post/circle/detail/${response.data.data}`,
            })
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      } else {
        putObj(this.getParams()).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: '更新成功',
              type: 'success'
            })
            this.$router.push({
              path: `/post/circle/detail/${this.id}`,
            })
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.circle-new-edit {
  .origin-cover {
    width: 148px;
    height: 148px;
    float: left;
    margin-right: 8px;
  }
}
</style>
